"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var startDate = (0, _get2["default"])(row, settings.path);
    if (startDate === null) {
      return '';
    }
    var formatType = settings.format ? settings.format : 'MM-DD-YYYY';
    var momentDate = startDate.substring(0, 10);
    var formatedDate = (0, _moment["default"])(momentDate).format(formatType);
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: "".concat(_style["default"].container, " text-nowrap")
    }, formatedDate);
  };
};